// B2-INT - Ünite 3: Grup Mülakat ve Assessment Center
// B2 seviyesinde grup mülakat stratejileri ve assessment center hazırlığı

export const B2INT_UNIT_3 = {
  'B2INT-U3-L1': {
    id: 'B2INT-U3-L1',
    title: 'Grup Tartışması Stratejileri',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Grup Mülakatları Nedir?',
          content: 'Havayolu mülakatlarında grup aşaması ÇOKÇA kullanılır!\n\n**Neden?**\n• Takım oyuncusu musun?\n• Liderlik + İşbirliği dengesi\n• Baskı altında iletişim\n• Dinleme becerileri\n\n⚠️ 6-12 aday bir arada, sadece 1-3\'ü geçer!'
        },
        {
          type: 'framework',
          title: '📋 Grup Tartışması Formatları',
          content: '**1. Açık Tartışma**\nKonu verilir, serbestçe tartışılır\nÖrn: "Should airlines charge for checked luggage?"\n\n**2. Problem Çözme**\nSenaryoya çözüm üretin\nÖrn: "A flight is delayed 5 hours. What should crew do?"\n\n**3. Önceliklendirme**\nListe verip sıralama\nÖrn: "Rank these 10 passenger complaints by priority"\n\n**4. Senaryo Oyunu**\nRol yaparak tartışma\nÖrn: "You\'re a cabin crew team - decide who does what"'
        },
        {
          type: 'scenario',
          title: '✈️ Örnek Grup Tartışması',
          dialogues: [
            {
              speaker: 'Moderatör',
              text: 'You have 20 minutes to discuss: "Should cabin crew wear uniforms or casual clothes?" You must reach a group decision.',
              translation: '20 dakikanız var tartışmak için: "Kabin ekibi üniforma mı yoksa günlük kıyafet mi giymeli?" Grup olarak bir karara varmalısınız.'
            },
            {
              speaker: 'İyi Aday (Açılış)',
              text: 'That\'s an interesting topic! Before we dive in, maybe we could first hear everyone\'s initial thoughts? I can start - I believe uniforms are important for professionalism, but I\'m open to hearing other perspectives.',
              translation: 'İlginç bir konu! Derine dalmadan önce, belki herkesin ilk düşüncelerini dinleyebilir miyiz? Ben başlayabilirim - üniformaların profesyonellik için önemli olduğunu düşünüyorum, ama diğer bakış açılarını duymaya açığım.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Açılış yaparak liderlik gösterdi AMA "I\'m open to hearing" diyerek baskıcı olmadı.',
              translation: ''
            },
            {
              speaker: 'İyi Aday (Dahil Etme)',
              text: 'I noticed Maria hasn\'t shared yet. Maria, what do you think about this? Do you have a different perspective?',
              translation: 'Maria\'nın henüz paylaşmadığını fark ettim. Maria, bu konuda ne düşünüyorsun? Farklı bir bakış açın var mı?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Sessiz kalan kişiyi dahil etti = Takım oyuncusu göstergesi!',
              translation: ''
            },
            {
              speaker: 'İyi Aday (Yapıcı Katılım)',
              text: 'That\'s a great point, Ahmed! Building on that, I think we could also consider the passenger\'s perspective. Uniforms help passengers identify crew members easily, especially in emergencies.',
              translation: 'Harika bir nokta, Ahmed! Buna ek olarak, yolcunun bakış açısını da düşünebiliriz. Üniformalar yolcuların ekip üyelerini kolayca tanımlamasına yardımcı olur, özellikle acil durumlarda.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ "Building on that" = Başkasının fikrini geliştirdi, rekabet değil işbirliği.',
              translation: ''
            },
            {
              speaker: 'İyi Aday (Zaman Yönetimi)',
              text: 'We have about 5 minutes left. Should we try to summarize our main points and work towards a decision?',
              translation: 'Yaklaşık 5 dakikamız kaldı. Ana noktalarımızı özetleyip bir karara doğru ilerlemeli miyiz?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Zaman takibi = Organizasyon becerisi gösterdi.',
              translation: ''
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Grup Tartışmasında Puanlanan Davranışlar',
          content: '**✅ YAPILMASI GEREKENLER:**\n• Herkesi dahil et\n• Aktif dinle (baş salla, göz teması)\n• Başkalarının fikirlerini geliştir\n• Zaman takibi yap\n• Özet ve sonuç öner\n• Saygılı ol\n\n**❌ YAPILMAMASI GEREKENLER:**\n• Sürekli konuşup başkalarını kesme\n• Sessiz kalıp hiç katkı yapmama\n• "I disagree" deyip alternatif sunmama\n• Tek başına karar almaya çalışma\n• Eleştiri karşısında savunmacı olma'
        },
        {
          type: 'info',
          title: '💬 Faydalı Grup Tartışması İfadeleri',
          content: '**Açılış:**\n• "Shall we start by...?"\n• "Maybe we could first define..."\n\n**Dahil Etme:**\n• "What do you think, [name]?"\n• "I\'d love to hear [name]\'s perspective"\n\n**Geliştirme:**\n• "Building on that idea..."\n• "That\'s a great point, and also..."\n\n**Özetleme:**\n• "So far we\'ve discussed..."\n• "It seems we agree that..."\n\n**Sonuç:**\n• "Should we now try to reach a decision?"\n• "To summarize our conclusion..."'
        },
        {
          type: 'warning',
          title: '⚠️ Kritik Uyarı: DENGE',
          content: '❌ Çok konuşan = Baskıcı, takım oyuncusu değil\n❌ Hiç konuşmayan = Pasif, katkı yok\n\n✅ İDEAL: Her 5-7 dakikada anlamlı katkı + Başkalarını dinleme + Kolaylaştırıcı rol'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Grup tartışmasında en iyi açılış?',
          options: [
            '"I think uniforms are essential and that\'s the answer."',
            '"Let\'s hear everyone\'s initial thoughts first."',
            '"I don\'t have an opinion."',
            '"Whoever speaks first should decide."'
          ],
          correctIndex: 1,
          explanation: 'Herkesi dahil eden, baskıcı olmayan açılış en iyisi!'
        }
      ]
    }
  },

  'B2INT-U3-L2': {
    id: 'B2INT-U3-L2',
    title: 'Role-Play Senaryoları',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Role-Play Nedir?',
          content: 'Assessment center\'da gerçek durumları canlandırırsın:\n\n• Zor yolcu ile konuşma\n• Ekip arkadaşına geri bildirim\n• Müşteri şikayeti çözme\n• Acil durum koordinasyonu\n\n⚠️ Seni izleyen değerlendiriciler var - GERÇEK gibi davran!'
        },
        {
          type: 'scenario',
          title: '✈️ Role-Play 1: Zor Yolcu',
          dialogues: [
            {
              speaker: 'Moderatör Açıklaması',
              text: 'You will role-play a conversation with an angry passenger (played by an assessor). The passenger missed their connection due to a delay and is demanding compensation.',
              translation: 'Kızgın bir yolcuyla (değerlendirici tarafından oynanan) bir konuşmayı canlandıracaksınız. Yolcu rötar nedeniyle aktarma uçuşunu kaçırdı ve tazminat talep ediyor.'
            },
            {
              speaker: 'Yolcu (Değerlendirici)',
              text: 'This is unacceptable! Your airline ruined my vacation! I demand a full refund and compensation NOW!',
              translation: 'Bu kabul edilemez! Havayolunuz tatilimi mahvetti! ŞİMDİ tam iade ve tazminat talep ediyorum!'
            },
            {
              speaker: 'Aday (İyi Yaklaşım)',
              text: 'I\'m truly sorry you\'ve had this experience, sir. I can absolutely understand how frustrating this must be for you. Let me see what I can do to help you right away.',
              translation: 'Bu deneyimi yaşadığınız için gerçekten üzgünüm, efendim. Bunun sizin için ne kadar sinir bozucu olduğunu kesinlikle anlıyorum. Hemen size yardımcı olmak için ne yapabileceğime bakayım.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Empati + Harekete geçme sözü. "I understand" = Sihirli kelime!',
              translation: ''
            },
            {
              speaker: 'Aday (devam)',
              text: 'Could you please tell me your booking details so I can check what options we have? I want to find the best solution for you.',
              translation: 'Lütfen bana rezervasyon bilgilerinizi söyleyebilir misiniz, böylece hangi seçeneklerimiz olduğunu kontrol edebilirim? Sizin için en iyi çözümü bulmak istiyorum.'
            },
            {
              speaker: 'Yolcu (daha agresif)',
              text: 'I don\'t want options! I want my money back! This is YOUR fault!',
              translation: 'Seçenek istemiyorum! Paramı geri istiyorum! Bu SİZİN hatanız!'
            },
            {
              speaker: 'Aday (sakin kalarak)',
              text: 'I hear you, and your frustration is completely valid. Regarding compensation, our customer service team has the authority to review and process such requests. What I can do right now is ensure you\'re rebooked on the next available flight and escalate your compensation request to my supervisor immediately. Would that help?',
              translation: 'Sizi duyuyorum ve hayal kırıklığınız tamamen geçerli. Tazminat konusunda, müşteri hizmetleri ekibimiz bu tür talepleri inceleme ve işleme yetkisine sahip. Şu anda yapabileceğim, bir sonraki müsait uçuşa yeniden rezervasyon yapmanızı sağlamak ve tazminat talebinizi hemen amirlerime iletmek. Bu yardımcı olur mu?'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Role-Play Puanlama Kriterleri',
          content: '✅ **Empati:** "I understand how frustrating..."\n✅ **Aktif Dinleme:** Yolcunun ne istediğini anlamak\n✅ **Çözüm Odaklı:** Yapabileceklerini sunmak\n✅ **Escalation:** Yetkisi olmayan konularda üst\'e yönlendirme\n✅ **Profesyonellik:** Kışkırtmaya kapılmamak\n✅ **Takip:** Somut adım önermek'
        },
        {
          type: 'scenario',
          title: '✈️ Role-Play 2: Ekip Arkadaşına Geri Bildirim',
          dialogues: [
            {
              speaker: 'Moderatör Açıklaması',
              text: 'Role-play: You need to give feedback to a colleague (played by assessor) who has been late to briefings 3 times this week.',
              translation: 'Role-play: Bu hafta 3 kez brifinglara geç kalan bir meslektaşınıza (değerlendirici tarafından oynanan) geri bildirim vermeniz gerekiyor.'
            },
            {
              speaker: 'Aday (Açılış)',
              text: 'Hi Sarah, do you have a moment? I wanted to chat with you about something. It\'s not a big deal, but I thought it\'s better to talk directly.',
              translation: 'Merhaba Sarah, bir dakikan var mı? Seninle bir şey hakkında konuşmak istedim. Büyük bir şey değil, ama direkt konuşmanın daha iyi olacağını düşündüm.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I\'ve noticed you\'ve been arriving a bit late to briefings recently. Is everything okay? I\'m asking because I want to make sure you\'re alright and also because the team relies on everyone being on time.',
              translation: 'Son zamanlarda brifinglere biraz geç geldiğini fark ettim. Her şey yolunda mı? Soruyorum çünkü iyi olduğundan emin olmak istiyorum ve ayrıca takım herkesin zamanında olmasına güveniyor.'
            },
            {
              speaker: 'Sarah (Değerlendirici)',
              text: 'I know, I\'m sorry. My transportation has been really unreliable lately.',
              translation: 'Biliyorum, özür dilerim. Son zamanlarda ulaşımım gerçekten güvenilmez oldu.'
            },
            {
              speaker: 'Aday (Çözüm Odaklı)',
              text: 'I understand, transportation issues can be really stressful. Would it help if we shared contact info? I could message you if there\'s any change to the briefing time, or maybe you could leave a bit earlier on days you\'re worried about traffic?',
              translation: 'Anlıyorum, ulaşım sorunları gerçekten stresli olabilir. İletişim bilgilerini paylaşsak yardımcı olur mu? Brifing saatinde herhangi bir değişiklik olursa sana mesaj atabilirim, veya belki trafikten endişelendiğin günlerde biraz daha erken çıkabilirsin?'
            }
          ]
        },
        {
          type: 'info',
          title: '💡 Geri Bildirim Verme Formülü: SBI',
          content: '**S - Situation (Durum)**\n"I noticed that this week..."\n\n**B - Behavior (Davranış)**\n"You\'ve been arriving late to briefings..."\n\n**I - Impact (Etki)**\n"This affects the team because..."\n\n➕ **Çözüm Öner**\n"Would it help if...?"'
        },
        {
          type: 'warning',
          title: '⚠️ Role-Play\'de Yapılmaması Gerekenler',
          content: '❌ Karakter kırma - role-play\'i ciddiye almamak\n❌ Değerlendiriciyle tartışmak\n❌ "Gerçek hayatta bunu yapmazdım" demek\n❌ Aşırı uzun sessizlik - düşün ama konuş!\n❌ Robotik cevaplar - doğal ol'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Kızgın yolcuya ilk tepki ne olmalı?',
          options: [
            '"Please calm down."',
            '"I understand how frustrating this is."',
            '"It\'s not my fault."',
            '"Wait here, I\'ll get my manager."'
          ],
          correctIndex: 1,
          explanation: 'Empati ile başla! "Calm down" genellikle işe yaramaz.'
        }
      ]
    }
  },

  'B2INT-U3-L3': {
    id: 'B2INT-U3-L3',
    title: 'Assessment Center Tips',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Assessment Center Nedir?',
          content: 'Tüm gün süren değerlendirme günü:\n\n⏰ Tipik Program:\n• 09:00 - Karşılama, tanışma\n• 09:30 - Grup tartışması\n• 11:00 - Bireysel görüşmeler\n• 12:30 - Öğle yemeği (DİKKAT: Bu da değerlendirme!)\n• 14:00 - Role-play\n• 15:30 - Yazılı test / Dil testi\n• 17:00 - Kapanış'
        },
        {
          type: 'info',
          title: '🔍 Değerlendirilen Yetkinlikler',
          content: '**1. İletişim Becerileri**\n• Açık konuşma\n• Aktif dinleme\n• İngilizce yeterliliği\n\n**2. Takım Çalışması**\n• İşbirliği\n• Başkalarını destekleme\n• Esneklik\n\n**3. Problem Çözme**\n• Analitik düşünce\n• Yaratıcılık\n• Karar verme\n\n**4. Müşteri Odaklılık**\n• Empati\n• Hizmet tutkusu\n• Çözüm odaklılık\n\n**5. Profesyonellik**\n• Görünüm\n• Tutum\n• Zaman yönetimi'
        },
        {
          type: 'scenario',
          title: '✈️ Gizli Değerlendirme Anları',
          dialogues: [
            {
              speaker: 'Uyarı',
              text: 'Assessment center\'da HER AN değerlendirilirsin! Sadece resmi aktivitelerde değil...',
              translation: ''
            },
            {
              speaker: 'Senaryo 1: Öğle Yemeği',
              text: 'During lunch, assessors observe: Do you talk to other candidates? Are you polite to serving staff? Do you check your phone constantly?',
              translation: 'Öğle yemeğinde değerlendiriciler gözlemler: Diğer adaylarla konuşuyor musun? Servis personeline kibar mısın? Sürekli telefonunu kontrol ediyor musun?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Diğer adaylarla sohbet et, rekabet değil dostluk\n✅ Garsonlara "please" ve "thank you" de\n✅ Telefonu çantada bırak',
              translation: ''
            },
            {
              speaker: 'Senaryo 2: Bekleme Odası',
              text: 'While waiting: Are you friendly to other candidates? Do you help someone who seems lost? Do you complain about the long wait?',
              translation: 'Beklerken: Diğer adaylara dostça mısın? Kaybolmuş görünen birine yardım ediyor musun? Uzun beklemeden şikayet ediyor musun?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Gülümse, göz teması kur\n✅ Basit sohbet başlat: "Have you been to an assessment day before?"\n✅ Şikayet etme, sabırlı ol',
              translation: ''
            },
            {
              speaker: 'Senaryo 3: Koridor Karşılaşması',
              text: 'If you bump into an assessor in the hallway or bathroom, they note: Did you smile and say hello? Were you professional?',
              translation: 'Koridorda veya tuvalette bir değerlendiriciyle karşılaşırsan, not ederler: Gülümsedin ve merhaba dedin mi? Profesyonel miydin?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Her zaman gülümse ve selamla\n✅ "Good morning!" veya "Hello!" yeterli\n✅ Profesyonel tutumunu koru - asla "off-duty" değilsin',
              translation: ''
            }
          ]
        },
        {
          type: 'checklist',
          title: '✅ Assessment Day Hazırlık Listesi',
          content: '**ÖNCESİ:**\n☐ Kıyafetlerini önceki gece hazırla (temiz, ütülü)\n☐ Adres ve ulaşımı kontrol et\n☐ CV kopyası, kimlik, kalem getir\n☐ Erken yat - dinlenmiş görün\n\n**GÜN İÇİNDE:**\n☐ 15-20 dakika erken git\n☐ Telefonu sessize al (veya kapat)\n☐ Herkese gülümse ve merhaba de\n☐ Aktif dinle - başınla onayla\n☐ Su iç, enerji koru\n☐ Şikayet etme, pozitif kal\n\n**SONRASI:**\n☐ Teşekkür e-postası gönder (opsiyonel ama iyi)'
        },
        {
          type: 'warning',
          title: '⚠️ En Yaygın Hatalar',
          content: '**1. Geç Kalmak**\nİlk izlenim ÖNEMLİ - 15 dk erken ol\n\n**2. Telefon**\nDeğerlendirme sırasında asla bakma\n\n**3. Diğer Adaylara Rekabet**\nRakip değil, potansiyel takım arkadaşı gibi davran\n\n**4. Öğle Yemeğinde Rahatlama**\nBu da test - profesyonel kal\n\n**5. Yorgunluk Gösterme**\nGün sonu bile enerjik ol - son izlenim de önemli!'
        },
        {
          type: 'tip',
          content: '💡 ALTIN KURAL: Assessment center boyunca "Şu anda beni bir yolcu olarak görse ne düşünürdü?" diye sor. Kabin memuru imajını HER AN yansıt!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Öğle yemeğinde değerlendirme olur mu?',
          options: [
            'Hayır, sadece resmi aktivitelerde',
            'Evet, her an değerlendirilirsin',
            'Sadece yemek seçimine bakılır',
            'Yemek yeme değerlendirilmez'
          ],
          correctIndex: 1,
          explanation: 'Her an değerlendirme altındasın - öğle yemeği dahil!'
        }
      ]
    }
  },

  'B2INT-U3-L4': {
    id: 'B2INT-U3-L4',
    title: 'Pratik: Grup Simülasyonu',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 Tam Grup Mülakat Simülasyonu',
          content: 'Şimdi tam bir grup tartışması göreceğiz.\n\n6 aday: Ali, Ayşe, Can, Deniz, Ece, Fatih\nKonu: "Should airlines ban young children in business class?"\nSüre: 20 dakika'
        },
        {
          type: 'scenario',
          title: '✈️ Grup Tartışması Örneği',
          dialogues: [
            {
              speaker: 'Moderatör',
              text: 'You have 20 minutes to discuss whether airlines should ban children under 5 from business class. Please reach a group conclusion.',
              translation: '20 dakikanız var, havayollarının 5 yaş altı çocukları business class\'tan yasaklayıp yasaklamaması gerektiğini tartışmak için. Lütfen grup olarak bir sonuca varın.'
            },
            {
              speaker: 'Ali (Açılış - İYİ)',
              text: 'This is an interesting topic! Before we share opinions, maybe we could consider both the business traveler\'s and the family\'s perspective? Would anyone like to start?',
              translation: 'İlginç bir konu! Görüşlerimizi paylaşmadan önce, belki hem iş seyahati yapanın hem de ailenin bakış açısını düşünebilir miyiz? Biri başlamak ister mi?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Yapıyı önerdi + başkalarını davet etti = Kolaylaştırıcı liderlik',
              translation: ''
            },
            {
              speaker: 'Can (KÖTÜ ÖRNEK)',
              text: 'I think it\'s obvious. Children should be banned. They cry, they\'re annoying, and business travelers pay more. End of discussion.',
              translation: 'Bence açık. Çocuklar yasaklanmalı. Ağlıyorlar, can sıkıcılar ve iş seyahati yapanlar daha fazla ödüyor. Tartışma sonu.'
            },
            {
              speaker: 'Tavsiye',
              text: '❌ Baskıcı, kapalı fikirli, tartışmayı kapattı = KÖTÜ!',
              translation: ''
            },
            {
              speaker: 'Ayşe (Dengeli Görüş - İYİ)',
              text: 'I see Can\'s point, but I\'d also like to consider the family perspective. Parents sometimes need to travel with young children for important reasons - maybe a family emergency. Also, as future cabin crew, our job would be to help all passengers...',
              translation: 'Can\'ın bakış açısını anlıyorum, ama aile perspektifini de düşünmek isterdim. Ebeveynlerin bazen önemli nedenlerle küçük çocuklarla seyahat etmesi gerekiyor - belki bir aile acil durumu. Ayrıca, gelecekteki kabin ekibi olarak, işimiz tüm yolculara yardım etmek olurdu...'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ "I see your point, but..." = Saygılı karşıt görüş',
              translation: ''
            },
            {
              speaker: 'Deniz (Sessiz Kalmış - Sorun)',
              text: '...',
              translation: '(5 dakikadır hiçbir şey söylemedi)'
            },
            {
              speaker: 'Ece (Dahil Etme - İYİ)',
              text: 'Deniz, I\'d love to hear your thoughts. Do you have any experience traveling with families that might help our discussion?',
              translation: 'Deniz, düşüncelerini duymak isterim. Tartışmamıza yardımcı olabilecek ailelerle seyahat deneyimin var mı?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Sessiz kişiyi dahil etti = Takım oyuncusu',
              translation: ''
            },
            {
              speaker: 'Fatih (Çözüm Önerisi - İYİ)',
              text: 'What if instead of a ban, airlines offered a family-friendly zone in business class, or trained crew to specifically assist families? That way, both groups are accommodated.',
              translation: 'Ya yasaklamak yerine havayolları business class\'ta aile dostu bir bölge sunsa veya ailelere özellikle yardım etmek için ekibi eğitse? Bu şekilde her iki grup da karşılanır.'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Yaratıcı orta yol çözümü = Problem çözme becerisi',
              translation: ''
            },
            {
              speaker: 'Ali (Özetleme - İYİ)',
              text: 'We have about 3 minutes left. It seems most of us lean towards finding a middle ground rather than an outright ban. Shall we summarize: Instead of banning children, airlines could offer designated family areas and better crew training. Does everyone agree?',
              translation: 'Yaklaşık 3 dakikamız kaldı. Çoğumuz tamamen yasaklamak yerine orta yol bulmaya eğiliyoruz gibi görünüyor. Özetleyelim: Çocukları yasaklamak yerine havayolları belirlenmiş aile alanları ve daha iyi ekip eğitimi sunabilir. Herkes hemfikir mi?'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ Zaman takibi + Özetleme + Sonuç = Mükemmel kapanış',
              translation: ''
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Aday Değerlendirmesi',
          content: '**✅ İLERİ GEÇENLER:**\n• **Ali:** Kolaylaştırıcı, zaman yönetimi, özetleme\n• **Ayşe:** Dengeli görüş, saygılı karşıtlık\n• **Ece:** Başkalarını dahil etti\n• **Fatih:** Yaratıcı çözüm\n\n**❌ ELENEBİLECEK:**\n• **Can:** Baskıcı, kapalı fikirli\n• **Deniz:** Hiç katkı yapmadı'
        },
        {
          type: 'tip',
          content: '💡 İDEAL KATKIM MİKTARI: Grup boyutuna göre değişir. 6 kişilik grupta, 20 dakikada 3-5 anlamlı katkı hedefle. Her 4-5 dakikada bir konuş - ama kaliteli konuş!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Grup tartışmasında hangi davranış en kötü?',
          options: [
            'Başkalarının fikrini geliştirmek',
            'Tartışmayı erken kapatmak ve tek görüşe zorlamak',
            'Sessiz kalan kişileri dahil etmek',
            'Zaman takibi yapmak'
          ],
          correctIndex: 1,
          explanation: '"End of discussion" gibi kapatan ifadeler çok kötü - baskıcı liderlik!'
        }
      ]
    }
  },

  'B2INT-U3-EXAM': {
    id: 'B2INT-U3-EXAM',
    title: 'B2 Interview Final Exam',
    type: 'final_exam',
    content: {
      timeLimit: 45,
      passingScore: 70,
      questions: [
        {
          type: 'multipleChoice',
          question: 'In the STAR method, what does "A" stand for?',
          options: ['Attitude', 'Action', 'Answer', 'Ability'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Which part of a STAR answer should be the longest?',
          options: ['Situation', 'Task', 'Action', 'Result'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'In an "above and beyond" example, what is the key element?',
          options: ['Manager\'s request', 'Your own initiative', 'Long working hours', 'Spending money'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'A passenger refuses to fasten their seat belt. What is the first step?',
          options: ['Call security', 'Calmly explain the safety requirement', 'Ignore it', 'Report to captain'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'During a medical emergency, what is the PA announcement for?',
          options: ['To scare passengers', 'To call for medical personnel', 'To alert the pilot', 'To wake everyone up'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'When two passengers are arguing, what should you NOT do?',
          options: ['Approach calmly', 'Take one side', 'Listen to both parties', 'Suggest a solution'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What is the best opening in a group discussion?',
          options: [
            '"I am right"',
            '"Let\'s hear everyone\'s opinion"',
            '"No need to discuss"',
            'Stay silent'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What should you do during lunch at an assessment center?',
          options: ['Check your phone', 'Socialize with other candidates', 'Eat alone', 'Complain about the process'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In a role-play, what is the best first response to an angry passenger?',
          options: [
            '"Calm down please"',
            '"I understand your frustration"',
            '"It\'s not my fault"',
            '"Wait for my manager"'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What should you do about a quiet person in a group discussion?',
          options: ['Ignore them', 'Speak for them', 'Ask for their opinion and include them', 'Complain to the moderator'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'A colleague is not doing their job properly. What is the best first approach?',
          options: ['Complain immediately', 'Privately ask if they need support', 'Tell others about it', 'Ignore it'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In a teamwork question, what should you emphasize?',
          options: ['Only your success', 'Team\'s mistakes', 'Your contribution AND collective success', 'That you work better alone'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'How early should you arrive at an assessment center?',
          options: ['Exactly on time', '5 minutes early', '15-20 minutes early', '1 hour early'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'In a 20-minute group discussion with 6 people, how many contributions are ideal?',
          options: ['Speak once', '3-5 meaningful contributions', 'Talk constantly', 'Don\'t speak at all'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What is the most important principle in B2-INT interviews?',
          options: [
            'Always be right',
            'Empathy, professionalism, and solution-focused approach',
            'Beat other candidates',
            'Speak as little as possible'
          ],
          correctIndex: 1
        }
      ]
    }
  }
};

export default B2INT_UNIT_3;
